"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCongridProjects = exports.handleConfigModal = exports.handleMetas = exports.handleLink = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const currentReducer = require("./current");
const filesReducer = require("./files");
const projectsReducer = require("./projects");
const linkReducer = require("./link");
const metasReducer = require("./metas");
const configModalReducer = require("./configModal");
const congridProjectsReducer = require("./congridProjects");
exports.initialState = {
    current: Object.assign({}, currentReducer.initialState),
    files: Object.assign({}, filesReducer.initialState),
    link: Object.assign({}, linkReducer.initialState),
    projects: Object.assign({}, projectsReducer.initialState),
    metas: Object.assign({}, metasReducer.initialState),
    configModal: Object.assign({}, configModalReducer.initialState),
    congridProjects: Object.assign({}, congridProjectsReducer.initialState)
};
const currentLens = monocle.Lens.fromProp('current');
const filesLens = monocle.Lens.fromProp('files');
const projectsLens = monocle.Lens.fromProp('projects');
const linkLens = monocle.Lens.fromProp('link');
const metasLens = monocle.Lens.fromProp('metas');
const configModalLens = monocle.Lens.fromProp('configModal');
const congridProjectsLens = monocle.Lens.fromProp('congridProjects');
const handleFiles = (action) => (state) => {
    const fn = filesReducer.methods[action.type];
    if (fn) {
        const current = filesLens.get(state);
        return filesLens.set(fn(current, action))(state);
    }
    return state;
};
const handleProjects = (action) => (state) => {
    const fn = projectsReducer.methods[action.type];
    if (fn) {
        const current = projectsLens.get(state);
        return projectsLens.set(fn(current, action))(state);
    }
    return state;
};
const handleCurrent = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        const current = currentLens.get(state);
        return currentLens.set(fn(current, action))(state);
    }
    return state;
};
const handleLink = (action) => (state) => {
    const fn = linkReducer.methods[action.type];
    if (fn) {
        const current = linkLens.get(state);
        return linkLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleLink = handleLink;
const handleMetas = (action) => (state) => {
    const fn = metasReducer.methods[action.type];
    if (fn) {
        const current = metasLens.get(state);
        return metasLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleMetas = handleMetas;
const handleConfigModal = (action) => (state) => {
    const fn = configModalReducer.methods[action.type];
    if (fn) {
        const current = configModalLens.get(state);
        return configModalLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleConfigModal = handleConfigModal;
const handleCongridProjects = (action) => (state) => {
    const fn = congridProjectsReducer.methods[action.type];
    if (fn) {
        const current = congridProjectsLens.get(state);
        return congridProjectsLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCongridProjects = handleCongridProjects;
// Reducer
exports.default = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.compose(handleFiles(action), handleProjects(action), handleCurrent(action), (0, exports.handleLink)(action), (0, exports.handleMetas)(action), (0, exports.handleConfigModal)(action), (0, exports.handleCongridProjects)(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map